import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { groupBy } from '@progress/kendo-data-query';
import moment from 'moment';
import { lastValueFrom } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { CluCashOpItem } from '../@models/clucashops.model';
import { CluTickItem } from '../@models/clutick.model';
import { RxCluCompteTxTmpDocumentType } from '../@schemas/clu_comptet.schema';
import { RxCluTickEnteteDocumentType } from '../@schemas/clu_tickentete.schema';
import { RxCluCashOpsDocument, RxCluCompteTxTmpDocument, RxCluTickDuplicataDocument, RxCluZJetDocument, RxCluZLogDocument, RxCluZTickTraceDocument } from './m-cashdesk-core-rxdb';
import { CashDeskCoreRxDbService } from './m-cashdesk-core-rxdb.service';
import { CashDeskZCluJetService } from './m-cashdesk-zclujet.service';
import { RxCluTickDuplicataDocumentType } from '../@schemas/clu_tickduplicata.schema';
import { CluAgentService } from 'src/app/utils/clu-agent/clu-agent.service';
import { ApiCluAgentService } from 'src/app/services/api-clu-agent.service';
import { TauriService } from 'src/app/services/tauri/tauri.service';

@Injectable()
export class CashDeskSyncUpService {

    constructor(
        private _cashDeskRxDbService : CashDeskCoreRxDbService,
        private _cashDeskZCluJetService : CashDeskZCluJetService,
        private httpClient: HttpClient,
        private apiService: ApiService,
        private _apiCluAgentService: ApiCluAgentService,
        private coreService : CoreService,
        private cluAgentService: CluAgentService,
        private tauriService: TauriService
    ) {
    }

    private isOnline : boolean;

    intervalID_TICKET : any;
    intervalID_CLIENT : any;
    intervalID_CASHOP : any;
    intervalID_CLUJET : any;
    intervalID_TICKET_FEED : any;
    intervalID_CLIENT_FEED : any;
    intervalID_CASHOP_FEED : any;
    intervalID_CLUJET_FEED : any;
    intervalID_AGENT_TICKET : any;
    start(){
        console.log('start');
        window.addEventListener('online', async() => { console.log('online_event'); this.isOnline = true; await this._cashDeskZCluJetService.doLogCashDeskOnlineEvent_JetFn(); });
        window.addEventListener('offline', async() => { console.log('offline_event'); this.isOnline = false; await this._cashDeskZCluJetService.doLogCashDeskOfflineEvent_JetFn(); });
        this.intervalID_TICKET = setInterval(this.doRunTicketSyncUpAction_SyncUp.bind(this), 8000);//12000
        this.intervalID_CLIENT = setInterval(this.doRunClientSyncUpAction_SyncUp.bind(this), 8000);//12000
        this.intervalID_CASHOP = setInterval(this.doRunCashopSyncUpAction_SyncUp.bind(this), 8000);//12000
        this.intervalID_CLUJET = setInterval(this.doRunZCluJetItemSyncUpAction_SyncUp.bind(this), 8000);//12000
        this.intervalID_TICKET_FEED = setInterval(this.doGetTicketSyncUpFeedResultAction_SyncUp.bind(this), 50000);//750000
        this.intervalID_CLIENT_FEED = setInterval(this.doGetClientSyncUpFeedResultAction_SyncUp.bind(this), 50000);//750000
        this.intervalID_CASHOP_FEED = setInterval(this.doGetCashopSyncUpFeedResultAction_SyncUp.bind(this), 50000);//750000
        this.intervalID_CLUJET_FEED = setInterval(this.doGetCluJetItemSyncUpFeedResultAction_SyncUp.bind(this), 50000);//750000
        this.intervalID_AGENT_TICKET = setInterval(this.doRunTicketSyncUpAgentAction_SyncUp.bind(this), 9000);
    }

    stop(){
        console.log('stop');
        clearInterval(this.intervalID_TICKET);
        clearInterval(this.intervalID_CLIENT);
        clearInterval(this.intervalID_CASHOP);
        clearInterval(this.intervalID_TICKET_FEED);
        clearInterval(this.intervalID_CLIENT_FEED);
        clearInterval(this.intervalID_CASHOP_FEED);
        clearInterval(this.intervalID_AGENT_TICKET);
        //this.connectionSub.unsubscribe();
    }

    // #region Ticket
    public async doForceTicketSyncUpAction_SyncUp() {
        //this.doRunClientSyncUpAction_SyncUp();
        await this.doRunTicketSyncUpAction_SyncUp();
        //this.doRunCashopSyncUpAction_SyncUp();
    }

    private async doRunTicketSyncUpAgentAction_SyncUp(){
        let _canSend = await this.canSendItemsToAgent();
        if(!_canSend) return;
        //console.log('doRunTicketSyncUpAction_SyncUp' , new Date());
        let CLU_TICKET_ITEMS : CluTickItem[] = [];
        if (this.tauriService.isTauri) {
            const ticketItems = await this.tauriService.doGetCluTickItemsAction({ ZSYNCAGENTUP_FLAG: 0 });
            CLU_TICKET_ITEMS = ticketItems.map((item: any) => Object.assign(new CluTickItem(), item));
        } else {
            const query = this._cashDeskRxDbService.db.clutickentete.find({ selector :
                {
                    "ZSYNCAGENTUP_FLAG" : { "$eq": 0 },
                    "DO_TOTALTTC": { "$gt": 0 }
                }, sort: [] });
            const res = await query.exec();
            await Promise.all(res.map(async (enteteItem : RxCluTickEnteteDocumentType) => {
                const CLU_TICK_ITEM = await this.runQuery_doGetCluTickItem(enteteItem.DO_PIECE_INTERNAL);
                CLU_TICKET_ITEMS.push(CLU_TICK_ITEM);
            }));
        }
        //if(CLU_TICKET_ITEMS && CLU_TICKET_ITEMS.length > 0) { console.log(CLU_TICKET_ITEMS); }
        if(CLU_TICKET_ITEMS.length == 0) return;
        let reqParams = { TICKET_ITEMS : CLU_TICKET_ITEMS };
        const resSyncUp = await lastValueFrom(this.httpClient.post<any>(this._apiCluAgentService.endPoints!.doRunTicketSyncUpAction_CashDeskSync, reqParams)).catch((error: HttpErrorResponse) => { console.log("error: ", error); return "ERROR_CATCHED" });
        if(!resSyncUp || resSyncUp == "ERROR_CATCHED") return;
        for(const _cluTicketItem of CLU_TICKET_ITEMS){
            if (this.tauriService.isTauri) {
                for (var i = 0; i < CLU_TICKET_ITEMS.length; i++) {
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCAGENTUP_FLAG = 1;
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCAGENTUP_STATUS = 'sent';
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCAGENTUP_ERROR_MESSAGE = '';
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCAGENTUP_DATETIME = moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCAGENTUP_FEEDID = resSyncUp.FEED_ID;

                    await this.tauriService.doSaveCluTickEnteteAction(CLU_TICKET_ITEMS[i].ENTETE);
                }
            } else {
                const _cluTicketItem_ENTETE = await this._cashDeskRxDbService.db.clutickentete.findOne({ selector: { "DO_PIECE_INTERNAL": { "$eq": _cluTicketItem.ENTETE.DO_PIECE_INTERNAL } }, sort: [] }).exec();
                if(_cluTicketItem_ENTETE){
                    await _cluTicketItem_ENTETE.update({
                        $set :
                        {
                            'ZSYNCAGENTUP_FLAG' : 1,
                            'ZSYNCAGENTUP_STATUS' : 'sent',
                            'ZSYNCAGENTUP_ERROR_MESSAGE' : '',
                            'ZSYNCAGENTUP_DATETIME' : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
                            'ZSYNCAGENTUP_FEEDID' : resSyncUp.FEED_ID
                        }
                    });
                }
            }
        }
    }

    private async doRunTicketSyncUpAction_SyncUp(){
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doRunTicketSyncUpAction_SyncUp' , new Date());
        let CLU_TICKET_ITEMS : CluTickItem[] = [];
        if (this.tauriService.isTauri) {
            const ticketItems = await this.tauriService.doGetCluTickItemsAction({ ZSYNCUP_FLAG: 0 });
            CLU_TICKET_ITEMS = ticketItems.map((item: any) => Object.assign(new CluTickItem(), item));
        } else {
            const query = this._cashDeskRxDbService.db.clutickentete.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 0 }}, sort: [] });
            const res = await query.exec();

            await Promise.all(res.map(async (enteteItem : RxCluTickEnteteDocumentType) => {
                const CLU_TICK_ITEM = await this.runQuery_doGetCluTickItem(enteteItem.DO_PIECE_INTERNAL);
                CLU_TICKET_ITEMS.push(CLU_TICK_ITEM);
            }));
        }
        //if(CLU_TICKET_ITEMS && CLU_TICKET_ITEMS.length > 0) { console.log(CLU_TICKET_ITEMS); }
        if(CLU_TICKET_ITEMS.length == 0) return;
        let reqParams = { TICKET_ITEMS : CLU_TICKET_ITEMS };
        const resSyncUp = await lastValueFrom(this.httpClient.post<any>(this.apiService.endPointsFO.doRunTicketSyncUpAction_SyncUp, reqParams)).catch((error: HttpErrorResponse) => { console.log("error: ", error); return "ERROR_CATCHED" });
        if(!resSyncUp || resSyncUp == "ERROR_CATCHED") return;
        for(const _cluTicketItem of CLU_TICKET_ITEMS){
            if (this.tauriService.isTauri) {
                for (var i = 0; i < CLU_TICKET_ITEMS.length; i++) {
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCUP_FLAG = 1;
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCUP_STATUS = 'sent';
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCUP_ERROR_MESSAGE = '';
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCUP_DATETIME = moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
                    CLU_TICKET_ITEMS[i].ENTETE.ZSYNCUP_FEEDID = resSyncUp.FEED_ID;

                    await this.tauriService.doSaveCluTickEnteteAction(CLU_TICKET_ITEMS[i].ENTETE);
                }
            } else {
                const _cluTicketItem_ENTETE = await this._cashDeskRxDbService.db.clutickentete.findOne({ selector: { "DO_PIECE_INTERNAL": { "$eq": _cluTicketItem.ENTETE.DO_PIECE_INTERNAL } }, sort: [] }).exec();
                if(_cluTicketItem_ENTETE){
                    await _cluTicketItem_ENTETE.update({
                        $set :
                        {
                            'ZSYNCUP_FLAG' : 1,
                            'ZSYNCUP_STATUS' : 'sent',
                            'ZSYNCUP_ERROR_MESSAGE' : '',
                            'ZSYNCUP_DATETIME' : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
                            'ZSYNCUP_FEEDID' : resSyncUp.FEED_ID
                        }
                    });
                }
            }
        }
        setTimeout(this.doGetTicketSyncUpFeedResultAction_SyncUp.bind(this), 3000);
        await this.doRunTicketDuplicataSyncUpAction_SyncUp();
    }

    private async doGetTicketSyncUpFeedResultAction_SyncUp(){
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doGetTicketSyncUpFeedResultAction_SyncUp' , new Date());
        let res: any[];
        if (this.tauriService.isTauri) {
            res = await this.tauriService.doGetCluTickEntetesAction({ ZSYNCUP_FLAG: 1, ZSYNCUP_STATUS: ['sent', 'in_progress'] });
        } else {
            const query = this._cashDeskRxDbService.db.clutickentete.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_STATUS" : { "$in": ['sent', 'in_progress'] } }, sort: [] });
            res = await query.exec();
        }
        if(res.length == 0) return;
        const FEED_IDs = groupBy(res, [{ field : 'ZSYNCUP_FEEDID' }]).map((m : any) => m.value);
        //if(FEED_IDs && FEED_IDs.length > 0) { console.log(FEED_IDs); }
        FEED_IDs.forEach((FEED_ID : string) => {
            let _httpParams = new HttpParams().set('FEED_ID', FEED_ID);
            this.httpClient.get(this.apiService.endPointsFO.doGetTicketSyncUpFeedResultAction_SyncUp, { params : _httpParams}).subscribe(async (res : any) => {
                if(!res) {
                    // FEED NON RETROUVE COTE SERVEUR
                    if (this.tauriService.isTauri) {
                        const feedTicketsEntetes = await this.tauriService.doGetCluTickEntetesAction({ ZSYNCUP_FLAG: 1, ZSYNCUP_FEEDID: FEED_ID });
                        for (var i = 0; i < feedTicketsEntetes.length; i++) {
                            feedTicketsEntetes[i].ZSYNCUP_STATUS = 'unknown';
                            feedTicketsEntetes[i].ZSYNCUP_ERROR_MESSAGE = 'Feed non retrouvé sur le serveur';
                            await this.tauriService.doSaveCluTickEnteteAction(feedTicketsEntetes[i]);
                        }
                    } else {
                        const query_FEED = this._cashDeskRxDbService.db.clutickentete.find({ selector: { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_FEEDID" : { "$eq": FEED_ID } }, sort: [] });
                        const querySub_FEED = query_FEED.$.subscribe(_documents => {
                            if(_documents){
                                _documents.forEach(x => x.update({ $set : { 'ZSYNCUP_STATUS' : 'unknown', 'ZSYNCUP_ERROR_MESSAGE' : 'Feed non retrouvé sur le serveur' } }));
                            }
                            querySub_FEED.unsubscribe();
                        });
                    }
                }
                else {
                    // FEED RETROUVE METTRE A JOUR LES STATUS
                    res.LOG_ITEMS.forEach(async (_logItem : any) => {
                        if (this.tauriService.isTauri) {
                            const feedTicketsEntetes = await this.tauriService.doGetCluTickEntetesAction({ ZSYNCUP_FLAG: 1, ZSYNCUP_FEEDID: FEED_ID, DO_PIECE_INTERNAL: _logItem.DO_PIECE_INTERNAL });
                            if (feedTicketsEntetes && feedTicketsEntetes.length > 0) {
                                let _status : 'unknown' | 'pending' | 'sent' | 'in_progress' | 'completed' | 'error' = 'sent';
                                const _cluTicketItem_ENTETE = feedTicketsEntetes[0];
                                switch(_logItem.STATUS) { case 0 : _status = 'sent'; break; case 1 : _status = 'in_progress'; break; case 2 : _status = 'completed'; break; case 3 : _status = 'error'; break; }
                                _cluTicketItem_ENTETE.ZSYNCUP_STATUS = _status;
                                _cluTicketItem_ENTETE.ZSYNCUP_ERROR_MESSAGE = _logItem.ERROR_MESSAGE;
                                await this.tauriService.doSaveCluTickEnteteAction(_cluTicketItem_ENTETE);
                            }
                        } else {
                            const query_ENTETE = this._cashDeskRxDbService.db.clutickentete.findOne({ selector: { "ZSYNCUP_FEEDID" : { "$eq": FEED_ID }, "DO_PIECE_INTERNAL": { "$eq": _logItem.DO_PIECE_INTERNAL } }, sort: [] });
                            const querySub_ENTETE = query_ENTETE.$.subscribe(_cluTicketItem_ENTETE => {
                                if(_cluTicketItem_ENTETE){
                                    let _status : 'unknown' | 'pending' | 'sent' | 'in_progress' | 'completed' | 'error' = 'sent';
                                    switch(_logItem.STATUS) { case 0 : _status = 'sent'; break; case 1 : _status = 'in_progress'; break; case 2 : _status = 'completed'; break; case 3 : _status = 'error'; break; }
                                    _cluTicketItem_ENTETE.update({ $set : { 'ZSYNCUP_STATUS' : _status, 'ZSYNCUP_ERROR_MESSAGE' : _logItem.ERROR_MESSAGE } });
                                }
                                querySub_ENTETE.unsubscribe();
                            });
                        }
                    });
                }
            }, (err) => {
                console.log(err);
            });
        })
    }

    private async runQuery_doGetCluTickItem(DO_PIECE_INTERNAL : string) : Promise<CluTickItem> {
        const query_ENTETE = this._cashDeskRxDbService.db.clutickentete.findOne({ selector: { "DO_PIECE_INTERNAL": { "$eq": DO_PIECE_INTERNAL } }, sort: [] });
        const query_LIGNES = this._cashDeskRxDbService.db.clutickligne.find({ selector: { "DO_PIECE_INTERNAL": { "$eq": DO_PIECE_INTERNAL } }, sort: [] });
        const query_REGLEMENTS = this._cashDeskRxDbService.db.clutickreglement.find({ selector: { "DO_PIECE_INTERNAL": { "$eq": DO_PIECE_INTERNAL } }, sort: [] });
        let ENTETE = await query_ENTETE.exec();
        if (ENTETE == undefined) throw Error('Le document ' + DO_PIECE_INTERNAL +  ' ne semble pas exister.');
        let LIGNES = await query_LIGNES.exec();
        let REGLEMENTS = await query_REGLEMENTS.exec();
        let cluTickItem = new CluTickItem();
        cluTickItem.ENTETE = JSON.parse(JSON.stringify(ENTETE));
        cluTickItem.LIGNES = JSON.parse(JSON.stringify(LIGNES));
        cluTickItem.REGLEMENTS = JSON.parse(JSON.stringify(REGLEMENTS));
        return cluTickItem;
    }
    // #endregion

    // #region TicketDuplicata
    public async doRunTicketDuplicataSyncUpAction_SyncUp(){
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doRunTicketDuplicataSyncUpAction_SyncUp' , new Date());
        // #region InError
        /*const query_InError = this._cashDeskRxDbService.db.clutickduplicata.find({ selector : { "ZSYNCUP_STATUS" : { "$eq": "error" }}, sort: [] });
        const res_InError = await query_InError.exec();
        await Promise.all(res_InError.map(async (_ticketDuplicata_OP : RxCluTickDuplicata) => {
            await _ticketDuplicata_OP.update({
                $set :
                {
                    'ZSYNCUP_FLAG' : 0,
                    'ZSYNCUP_STATUS' : 'pending',
                    'ZSYNCUP_ERROR_MESSAGE' : '',
                    'ZSYNCUP_DATETIME' : '',
                    'ZSYNCUP_FEEDID' : ''
                }
            });
        }));*/
        // #endregion
        let CLU_DUPLICATA_ITEMS : any[] = [];
        if (this.tauriService.isTauri) {
            CLU_DUPLICATA_ITEMS = await this.tauriService.doGetDuplicataItemsAction({ ZSYNCUP_FLAG: 0, SORT_COLUMN: 'DUP_DATE_UTC', SORT_DIRECTION: 'ASC' });
        } else {
            const query = this._cashDeskRxDbService.db.clutickduplicata.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 0 }}, sort: [{ "DUP_DATE_UTC" : 'asc' }] });
            const res = await query.exec();
            await Promise.all(res.map(async (duplicata : RxCluTickDuplicataDocument) => {
                CLU_DUPLICATA_ITEMS.push(duplicata.toMutableJSON());
            }));
        }
        //if(CLU_DUPLICATA_ITEMS && CLU_DUPLICATA_ITEMS.length > 0) { console.log(CLU_DUPLICATA_ITEMS); }
        if(CLU_DUPLICATA_ITEMS.length == 0) return;
        let reqParams = { DUPLICATA_ITEMS : CLU_DUPLICATA_ITEMS };
        const resSyncUp = await lastValueFrom(this.httpClient.post<any>(this.apiService.endPointsFO.doRunTicketDuplicataSyncUpAction_SyncUp, reqParams));
        for(const _ticketDuplicata of CLU_DUPLICATA_ITEMS){
            if (this.tauriService.isTauri) {
                const _ticketDuplicata_OP = await this.tauriService.doGetFirstDuplicataItemAction({ DUP_PIECE_INTERNAL: _ticketDuplicata.DUP_PIECE_INTERNAL });
                if(_ticketDuplicata_OP){
                    _ticketDuplicata_OP.ZSYNCUP_FLAG = 1;
                    _ticketDuplicata_OP.ZSYNCUP_STATUS = 'sent';
                    _ticketDuplicata_OP.ZSYNCUP_ERROR_MESSAGE = '';
                    _ticketDuplicata_OP.ZSYNCUP_DATETIME = moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
                    _ticketDuplicata_OP.ZSYNCUP_FEEDID = resSyncUp.FEED_ID;
                    await this.tauriService.doSaveDuplicataItemAction(_ticketDuplicata_OP);
                }
            } else {
                const _ticketDuplicata_OP = await this._cashDeskRxDbService.db.clutickduplicata.findOne({ selector: { "DUP_PIECE_INTERNAL": { "$eq": _ticketDuplicata.DUP_PIECE_INTERNAL } }, sort: [] }).exec();
                if(_ticketDuplicata_OP){
                    await _ticketDuplicata_OP.update({
                        $set :
                        {
                            'ZSYNCUP_FLAG' : 1,
                            'ZSYNCUP_STATUS' : 'sent',
                            'ZSYNCUP_ERROR_MESSAGE' : '',
                            'ZSYNCUP_DATETIME' : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
                            'ZSYNCUP_FEEDID' : resSyncUp.FEED_ID
                        }
                    });
                }
            }
        }
        setTimeout(this.doGetTicketDuplicataSyncUpFeedResultAction_SyncUp.bind(this), 3000);
    }

    private async doGetTicketDuplicataSyncUpFeedResultAction_SyncUp() {
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doGetTicketDuplicataSyncUpFeedResultAction_SyncUp' , new Date());
        let res: any[];
        if (this.tauriService.isTauri) {
            res = await this.tauriService.doGetDuplicataItemsAction({ ZSYNCUP_FLAG: 1, ZSYNCUP_STATUS: ['sent', 'in_progress'] });
        } else {
            const query = this._cashDeskRxDbService.db.clutickduplicata.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_STATUS" : { "$in": ['sent', 'in_progress'] } }, sort: [] });
            res = await query.exec();
        }
        if(res.length == 0) return;
        const FEED_IDs = groupBy(res, [{ field : 'ZSYNCUP_FEEDID' }]).map((m : any) => m.value);
        //if(FEED_IDs && FEED_IDs.length > 0) { console.log(FEED_IDs); }
        FEED_IDs.forEach((FEED_ID : string) => {
            let _httpParams = new HttpParams().set('FEED_ID', FEED_ID);
            this.httpClient.get(this.apiService.endPointsFO.doGetTicketDuplicataSyncUpFeedResultAction_SyncUp, { params : _httpParams}).subscribe(async (res : any) => {
                if(!res) {
                    // FEED NON RETROUVE COTE SERVEUR
                    if (this.tauriService.isTauri) {
                        const query_FEED = await this.tauriService.doGetDuplicataItemsAction({ ZSYNCUP_FLAG: 1, ZSYNCUP_FEEDID: FEED_ID })
                        for (var i = 0; i < query_FEED.length; i++) {
                            query_FEED[i].ZSYNCUP_STATUS = 'unknown';
                            query_FEED[i].ZSYNCUP_ERROR_MESSAGE = 'Feed non retrouvé sur le serveur';
                            await this.tauriService.doSaveDuplicataItemAction(query_FEED[i]);
                        }
                    } else {
                        const query_FEED = this._cashDeskRxDbService.db.clutickduplicata.find({ selector: { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_FEEDID" : { "$eq": FEED_ID } }, sort: [] });
                        const querySub_FEED = query_FEED.$.subscribe(_documents => {
                            if(_documents){
                                _documents.forEach(x => x.update({ $set : { 'ZSYNCUP_STATUS' : 'unknown', 'ZSYNCUP_ERROR_MESSAGE' : 'Feed non retrouvé sur le serveur' } }));
                            }
                            querySub_FEED.unsubscribe();
                        });
                    }
                }
                else {
                    // FEED RETROUVE METTRE A JOUR LES STATUS
                    res.LOG_ITEMS.forEach(async (_logItem : any) => {
                        if (this.tauriService.isTauri) {
                            const _ticketDuplicata_OP = await this.tauriService.doGetFirstDuplicataItemAction({ ZSYNCUP_FEEDID: FEED_ID, DUP_PIECE_INTERNAL: _logItem.DUP_PIECE_INTERNAL });
                            if(_ticketDuplicata_OP){
                                let _status : 'unknown' | 'pending' | 'sent' | 'in_progress' | 'completed' | 'error' = 'sent';
                                switch(_logItem.STATUS) { case 0 : _status = 'sent'; break; case 1 : _status = 'in_progress'; break; case 2 : _status = 'completed'; break; case 3 : _status = 'error'; break; }
                                _ticketDuplicata_OP.ZSYNCUP_STATUS = _status;
                                _ticketDuplicata_OP.ZSYNCUP_ERROR_MESSAGE = _logItem.ERROR_MESSAGE;
                                await this.tauriService.doSaveDuplicataItemAction(_ticketDuplicata_OP);
                            }
                        } else {
                            const query_OP = this._cashDeskRxDbService.db.clutickduplicata.findOne({ selector: { "ZSYNCUP_FEEDID" : { "$eq": FEED_ID }, "DUP_PIECE_INTERNAL": { "$eq": _logItem.DUP_PIECE_INTERNAL } }, sort: [] });
                            const querySub_OP = query_OP.$.subscribe(_ticketDuplicata_OP => {
                                if(_ticketDuplicata_OP){
                                    let _status : 'unknown' | 'pending' | 'sent' | 'in_progress' | 'completed' | 'error' = 'sent';
                                    switch(_logItem.STATUS) { case 0 : _status = 'sent'; break; case 1 : _status = 'in_progress'; break; case 2 : _status = 'completed'; break; case 3 : _status = 'error'; break; }
                                    _ticketDuplicata_OP.update({ $set : { 'ZSYNCUP_STATUS' : _status, 'ZSYNCUP_ERROR_MESSAGE' : _logItem.ERROR_MESSAGE } });
                                }
                                querySub_OP.unsubscribe();
                            });
                        }
                    });
                }
            }, (err) => {
                console.log(err);
            });
        })
    }
    // #endregion

    // #region Client
    public async doForceClientSyncUpAction_SyncUp(){
        await this.doRunClientSyncUpAction_SyncUp();
    }

    private async doRunClientSyncUpAction_SyncUp(){
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doRunClientSyncUpAction_SyncUp' , new Date());
        const query = this._cashDeskRxDbService.db.clucomptetxtmp.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 0 }}, sort: [] });
        const res = await query.exec();
        let CLU_CLIENT_ITEMS : RxCluCompteTxTmpDocument[] = [];
        await Promise.all(res.map(async (clientItem : RxCluCompteTxTmpDocumentType) => {
            const CLU_TICK_ITEM = await this.runQuery_doGetCluClientItem(clientItem.CT_NUM_INTERNAL);
            CLU_CLIENT_ITEMS.push(CLU_TICK_ITEM);
        }));
        //if(CLU_CLIENT_ITEMS && CLU_CLIENT_ITEMS.length > 0) { console.log(CLU_CLIENT_ITEMS); }
        if(CLU_CLIENT_ITEMS.length == 0) return;
        let reqParams = { CLIENT_ITEMS : CLU_CLIENT_ITEMS };
        const resSyncUp = await lastValueFrom(this.httpClient.post<any>(this.apiService.endPointsFO.doRunClientSyncUpAction_SyncUp, reqParams));
        for(const _cluClientItem of CLU_CLIENT_ITEMS){
            const _cluClientItem_ENTETE = await this._cashDeskRxDbService.db.clucomptetxtmp.findOne({ selector: { "CT_NUM_INTERNAL": { "$eq": _cluClientItem.CT_NUM_INTERNAL } }, sort: [] }).exec();
            if(_cluClientItem_ENTETE){
                await _cluClientItem_ENTETE.update({
                    $set :
                    {
                        'ZSYNCUP_FLAG' : 1,
                        'ZSYNCUP_STATUS' : 'sent',
                        'ZSYNCUP_ERROR_MESSAGE' : '',
                        'ZSYNCUP_DATETIME' : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
                        'ZSYNCUP_FEEDID' : resSyncUp.FEED_ID
                    }
                });
            }
        }
        setTimeout(this.doGetClientSyncUpFeedResultAction_SyncUp.bind(this), 3000);
    }

    private async doGetClientSyncUpFeedResultAction_SyncUp(){
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doGetClientSyncUpFeedResultAction_SyncUp' , new Date());
        const query = this._cashDeskRxDbService.db.clucomptetxtmp.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_STATUS" : { "$in": ['sent', 'in_progress'] } }, sort: [] });
        const res = await query.exec();
        if(res.length == 0) return;
        const FEED_IDs = groupBy(res, [{ field : 'ZSYNCUP_FEEDID' }]).map((m : any) => m.value);
        //if(FEED_IDs && FEED_IDs.length > 0) { console.log(FEED_IDs); }
        FEED_IDs.forEach((FEED_ID : string) => {
            let _httpParams = new HttpParams().set('FEED_ID', FEED_ID);
            this.httpClient.get(this.apiService.endPointsFO.doGetClientSyncUpFeedResultAction_SyncUp, { params : _httpParams}).subscribe((res : any) => {
                if(!res) {
                    // FEED NON RETROUVE COTE SERVEUR
                    const query_FEED = this._cashDeskRxDbService.db.clucomptetxtmp.find({ selector: { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_FEEDID" : { "$eq": FEED_ID } }, sort: [] });
                    const querySub_FEED = query_FEED.$.subscribe(_documents => {
                        if(_documents){
                            _documents.forEach(x => x.update({ $set : { 'ZSYNCUP_STATUS' : 'unknown', 'ZSYNCUP_ERROR_MESSAGE' : 'Feed non retrouvé sur le serveur' } }));
                        }
                        querySub_FEED.unsubscribe();
                    });
                }
                else {
                    // FEED RETROUVE METTRE A JOUR LES STATUS
                    res.LOG_ITEMS.forEach((_logItem : any) => {
                        const query_ENTETE = this._cashDeskRxDbService.db.clucomptetxtmp.findOne({ selector: { "ZSYNCUP_FEEDID" : { "$eq": FEED_ID }, "CT_NUM_INTERNAL": { "$eq": _logItem.CT_NUM_INTERNAL } }, sort: [] });
                        const querySub_ENTETE = query_ENTETE.$.subscribe(_cluClientItem_ENTETE => {
                            if(_cluClientItem_ENTETE){
                                let _status : 'unknown' | 'pending' | 'sent' | 'in_progress' | 'completed' | 'error' = 'sent';
                                switch(_logItem.STATUS) { case 0 : _status = 'sent'; break; case 1 : _status = 'in_progress'; break; case 2 : _status = 'completed'; break; case 3 : _status = 'error'; break; }
                                _cluClientItem_ENTETE.update({ $set : { 'ZSYNCUP_STATUS' : _status, 'ZSYNCUP_ERROR_MESSAGE' : _logItem.ERROR_MESSAGE } });
                            }
                            querySub_ENTETE.unsubscribe();
                        });
                    });
                }
            }, (err) => {
                console.log(err);
            });
        })
    }

    private async runQuery_doGetCluClientItem(CT_NUM_INTERNAL : string) : Promise<RxCluCompteTxTmpDocument> {
        const query_CLIENT = this._cashDeskRxDbService.db.clucomptetxtmp.findOne({ selector: { "CT_NUM_INTERNAL": { "$eq": CT_NUM_INTERNAL } }, sort: [] });
        let CLIENT = await query_CLIENT.exec();
        if (CLIENT == undefined) throw Error('Le client ' + CT_NUM_INTERNAL +  ' ne semble pas exister.');
        let cluClientItem : RxCluCompteTxTmpDocument = CLIENT;
        return cluClientItem;
    }
    // #endregion

    // #region Cashop
    public async doForceCashopSyncUpAction_SyncUp(){
        await this.doRunCashopSyncUpAction_SyncUp();
    }

    private async doRunCashopSyncUpAction_SyncUp(){
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doRunCashopSyncUpAction_SyncUp' , new Date());
        const query = this._cashDeskRxDbService.db.clucashops.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 0 }}, sort: [] });
        const res = await query.exec();
        let CLU_CASHOP_ITEMS : CluCashOpItem[] = [];
        await Promise.all(res.map(async (cashopItem : RxCluCashOpsDocument) => {
            let CLU_CASHOP_ITEM = new CluCashOpItem(); CLU_CASHOP_ITEM.FROM_RXDOCUMENT(cashopItem);
            CLU_CASHOP_ITEMS.push(CLU_CASHOP_ITEM);
        }));
        //if(CLU_CASHOP_ITEMS && CLU_CASHOP_ITEMS.length > 0) { console.log(CLU_CASHOP_ITEMS); }
        if(CLU_CASHOP_ITEMS.length == 0) return;
        let reqParams = { CASHOP_ITEMS : CLU_CASHOP_ITEMS };
        const resSyncUp = await lastValueFrom(this.httpClient.post<any>(this.apiService.endPointsFO.doRunCashopSyncUpAction_SyncUp, reqParams));
        for(const _cluCashopItem of CLU_CASHOP_ITEMS){
            const _cluCashopItem_OP = await this._cashDeskRxDbService.db.clucashops.findOne({ selector: { "PK_ID": { "$eq": _cluCashopItem.PK_ID } }, sort: [] }).exec();
            if(_cluCashopItem_OP){
                await _cluCashopItem_OP.update({
                    $set :
                    {
                        'ZSYNCUP_FLAG' : 1,
                        'ZSYNCUP_STATUS' : 'sent',
                        'ZSYNCUP_ERROR_MESSAGE' : '',
                        'ZSYNCUP_DATETIME' : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
                        'ZSYNCUP_FEEDID' : resSyncUp.FEED_ID
                    }
                });
            }
        }
        setTimeout(this.doGetCashopSyncUpFeedResultAction_SyncUp.bind(this), 3000);
    }

    private async doGetCashopSyncUpFeedResultAction_SyncUp() {
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doGetCashopSyncUpFeedResultAction_SyncUp' , new Date());
        const query = this._cashDeskRxDbService.db.clucashops.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_STATUS" : { "$in": ['sent', 'in_progress'] } }, sort: [] });
        const res = await query.exec();
        if(res.length == 0) return;
        const FEED_IDs = groupBy(res, [{ field : 'ZSYNCUP_FEEDID' }]).map((m : any) => m.value);
        //if(FEED_IDs && FEED_IDs.length > 0) { console.log(FEED_IDs); }
        FEED_IDs.forEach((FEED_ID : string) => {
            let _httpParams = new HttpParams().set('FEED_ID', FEED_ID);
            this.httpClient.get(this.apiService.endPointsFO.doGetCashopSyncUpFeedResultAction_SyncUp, { params : _httpParams}).subscribe((res : any) => {
                if(!res) {
                    // FEED NON RETROUVE COTE SERVEUR
                    const query_FEED = this._cashDeskRxDbService.db.clucashops.find({ selector: { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_FEEDID" : { "$eq": FEED_ID } }, sort: [] });
                    const querySub_FEED = query_FEED.$.subscribe(_documents => {
                        if(_documents){
                            _documents.forEach(x => x.update({ $set : { 'ZSYNCUP_STATUS' : 'unknown', 'ZSYNCUP_ERROR_MESSAGE' : 'Feed non retrouvé sur le serveur' } }));
                        }
                        querySub_FEED.unsubscribe();
                    });
                }
                else {
                    // FEED RETROUVE METTRE A JOUR LES STATUS
                    res.LOG_ITEMS.forEach((_logItem : any) => {
                        const query_OP = this._cashDeskRxDbService.db.clucashops.findOne({ selector: { "ZSYNCUP_FEEDID" : { "$eq": FEED_ID }, "PK_ID": { "$eq": _logItem.PK_ID } }, sort: [] });
                        const querySub_OP = query_OP.$.subscribe(_cluCashopItem_OP => {
                            if(_cluCashopItem_OP){
                                let _status : 'unknown' | 'pending' | 'sent' | 'in_progress' | 'completed' | 'error' = 'sent';
                                switch(_logItem.STATUS) { case 0 : _status = 'sent'; break; case 1 : _status = 'in_progress'; break; case 2 : _status = 'completed'; break; case 3 : _status = 'error'; break; }
                                _cluCashopItem_OP.update({ $set : { 'ZSYNCUP_STATUS' : _status, 'ZSYNCUP_ERROR_MESSAGE' : _logItem.ERROR_MESSAGE } });
                            }
                            querySub_OP.unsubscribe();
                        });
                    });
                }
            }, (err) => {
                console.log(err);
            });
        })
    }
    // #endregion

    // #region ZCluJetItem
    public async doForceZCluJetItemSyncUpAction_SyncUp(){
        await this.doRunZCluJetItemSyncUpAction_SyncUp();
    }

    private async doRunZCluJetItemSyncUpAction_SyncUp(){
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        try
        {
            await this.doRunZCluZLogItemSyncUpAction_SyncUp();
            await this.doRunZCluZTickTraceItemSyncUpAction_SyncUp();
        } catch { }
        //console.log('doRunZCluJetItemSyncUpAction_SyncUp' , new Date());
        // #region InError
        /*const query_InError = this._cashDeskRxDbService.db.clujet.find({ selector : { "ZSYNCUP_STATUS" : { "$eq": "error" }}, sort: [] });
        const res_InError = await query_InError.exec();
        await Promise.all(res_InError.map(async (_zCluJetItem_OP : RxCluZJetDocument) => {
            await _zCluJetItem_OP.update({
                $set :
                {
                    'ZSYNCUP_FLAG' : 0,
                    'ZSYNCUP_STATUS' : 'pending',
                    'ZSYNCUP_ERROR_MESSAGE' : '',
                    'ZSYNCUP_DATETIME' : '',
                    'ZSYNCUP_FEEDID' : ''
                }
            });
        }));*/
        // #endregion

        const query = this._cashDeskRxDbService.db.clujet.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 0 }}, sort: [{ "JET_DATEEVENT" : 'asc' }] });
        const res = await query.exec();
        let CLU_JET_ITEMS : any[] = [];
        await Promise.all(res.map(async (jetItem : RxCluZJetDocument) => {
            CLU_JET_ITEMS.push(jetItem.toMutableJSON());
        }));
        //if(CLU_JET_ITEMS && CLU_JET_ITEMS.length > 0) { console.log(CLU_JET_ITEMS); }
        if(CLU_JET_ITEMS.length == 0) return;
        let reqParams = { JET_ITEMS : CLU_JET_ITEMS };
        const resSyncUp = await lastValueFrom(this.httpClient.post<any>(this.apiService.endPointsFO.doRunZCluJetItemSyncUpAction_SyncUp, reqParams));
        for(const _zCluJetItem of CLU_JET_ITEMS){
            const _zCluJetItem_OP = await this._cashDeskRxDbService.db.clujet.findOne({ selector: { "JET_GID": { "$eq": _zCluJetItem.JET_GID } }, sort: [] }).exec();
            if(_zCluJetItem_OP){
                await _zCluJetItem_OP.update({
                    $set :
                    {
                        'ZSYNCUP_FLAG' : 1,
                        'ZSYNCUP_STATUS' : 'sent',
                        'ZSYNCUP_ERROR_MESSAGE' : '',
                        'ZSYNCUP_DATETIME' : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
                        'ZSYNCUP_FEEDID' : resSyncUp.FEED_ID
                    }
                });
            }
        }
        setTimeout(this.doGetCluJetItemSyncUpFeedResultAction_SyncUp.bind(this), 3000);
    }

    private async doGetCluJetItemSyncUpFeedResultAction_SyncUp() {
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doGetCluJetItemSyncUpFeedResultAction_SyncUp' , new Date());
        const query = this._cashDeskRxDbService.db.clujet.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_STATUS" : { "$in": ['sent', 'in_progress'] } }, sort: [] });
        const res = await query.exec();
        if(res.length == 0) return;
        const FEED_IDs = groupBy(res, [{ field : 'ZSYNCUP_FEEDID' }]).map((m : any) => m.value);
        //if(FEED_IDs && FEED_IDs.length > 0) { console.log(FEED_IDs); }
        FEED_IDs.forEach((FEED_ID : string) => {
            let _httpParams = new HttpParams().set('FEED_ID', FEED_ID);
            this.httpClient.get(this.apiService.endPointsFO.doGetCluJetItemSyncUpFeedResultAction_SyncUp, { params : _httpParams}).subscribe((res : any) => {
                if(!res) {
                    // FEED NON RETROUVE COTE SERVEUR
                    const query_FEED = this._cashDeskRxDbService.db.clujet.find({ selector: { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_FEEDID" : { "$eq": FEED_ID } }, sort: [] });
                    const querySub_FEED = query_FEED.$.subscribe(_documents => {
                        if(_documents){
                            _documents.forEach(x => x.update({ $set : { 'ZSYNCUP_STATUS' : 'unknown', 'ZSYNCUP_ERROR_MESSAGE' : 'Feed non retrouvé sur le serveur' } }));
                        }
                        querySub_FEED.unsubscribe();
                    });
                }
                else {
                    // FEED RETROUVE METTRE A JOUR LES STATUS
                    res.LOG_ITEMS.forEach((_logItem : any) => {
                        const query_OP = this._cashDeskRxDbService.db.clujet.findOne({ selector: { "ZSYNCUP_FEEDID" : { "$eq": FEED_ID }, "JET_GID": { "$eq": _logItem.JET_GID } }, sort: [] });
                        const querySub_OP = query_OP.$.subscribe(_zCluJetItem_OP => {
                            if(_zCluJetItem_OP){
                                let _status : 'unknown' | 'pending' | 'sent' | 'in_progress' | 'completed' | 'error' = 'sent';
                                switch(_logItem.STATUS) { case 0 : _status = 'sent'; break; case 1 : _status = 'in_progress'; break; case 2 : _status = 'completed'; break; case 3 : _status = 'error'; break; }
                                _zCluJetItem_OP.update({ $set : { 'ZSYNCUP_STATUS' : _status, 'ZSYNCUP_ERROR_MESSAGE' : _logItem.ERROR_MESSAGE } });
                            }
                            querySub_OP.unsubscribe();
                        });
                    });
                }
            }, (err) => {
                console.log(err);
            });
        })
    }
    // #endregion

    // #region ZCluZLogItem
    public async doForceZCluZLogItemSyncUpAction_SyncUp(){
        await this.doRunZCluZLogItemSyncUpAction_SyncUp();
    }

    private async doRunZCluZLogItemSyncUpAction_SyncUp(){
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doRunZCluZLogItemSyncUpAction_SyncUp' , new Date());
        // #region InError
        /*const query_InError = this._cashDeskRxDbService.db.cluzlog.find({ selector : { "ZSYNCUP_STATUS" : { "$eq": "error" }}, sort: [] });
        const res_InError = await query_InError.exec();
        await Promise.all(res_InError.map(async (_zCluZLogItem_OP : RxCluZLogDocument) => {
            await _zCluZLogItem_OP.update({
                $set :
                {
                    'ZSYNCUP_FLAG' : 0,
                    'ZSYNCUP_STATUS' : 'pending',
                    'ZSYNCUP_ERROR_MESSAGE' : '',
                    'ZSYNCUP_DATETIME' : '',
                    'ZSYNCUP_FEEDID' : ''
                }
            });
        }));*/
        // #endregion

        const query = this._cashDeskRxDbService.db.cluzlog.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 0 }}, sort: [{ "LOG_DATEEVENT" : 'asc' }] });
        const res = await query.exec();
        let CLU_ZLOG_ITEMS : any[] = [];
        await Promise.all(res.map(async (zlogItem : RxCluZLogDocument) => {
            CLU_ZLOG_ITEMS.push(zlogItem.toMutableJSON());
        }));
        //if(CLU_ZLOG_ITEMS && CLU_ZLOG_ITEMS.length > 0) { console.log(CLU_ZLOG_ITEMS); }
        if(CLU_ZLOG_ITEMS.length == 0) return;
        let reqParams = { ZLOG_ITEMS : CLU_ZLOG_ITEMS };
        const resSyncUp = await lastValueFrom(this.httpClient.post<any>(this.apiService.endPointsFO.doRunZCluZLogItemSyncUpAction_SyncUp, reqParams));
        for(const _zCluZLogItem of CLU_ZLOG_ITEMS){
            const _zCluZLogItem_OP = await this._cashDeskRxDbService.db.cluzlog.findOne({ selector: { "LOG_GID": { "$eq": _zCluZLogItem.LOG_GID } }, sort: [] }).exec();
            if(_zCluZLogItem_OP){
                await _zCluZLogItem_OP.update({
                    $set :
                    {
                        'ZSYNCUP_FLAG' : 1,
                        'ZSYNCUP_STATUS' : 'sent',
                        'ZSYNCUP_ERROR_MESSAGE' : '',
                        'ZSYNCUP_DATETIME' : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
                        'ZSYNCUP_FEEDID' : resSyncUp.FEED_ID
                    }
                });
            }
        }
        setTimeout(this.doGetCluZLogItemSyncUpFeedResultAction_SyncUp.bind(this), 3000);
    }

    private async doGetCluZLogItemSyncUpFeedResultAction_SyncUp() {
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doGetCluZLogItemSyncUpFeedResultAction_SyncUp' , new Date());
        const query = this._cashDeskRxDbService.db.cluzlog.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_STATUS" : { "$in": ['sent', 'in_progress'] } }, sort: [] });
        const res = await query.exec();
        if(res.length == 0) return;
        const FEED_IDs = groupBy(res, [{ field : 'ZSYNCUP_FEEDID' }]).map((m : any) => m.value);
        //if(FEED_IDs && FEED_IDs.length > 0) { console.log(FEED_IDs); }
        FEED_IDs.forEach((FEED_ID : string) => {
            let _httpParams = new HttpParams().set('FEED_ID', FEED_ID);
            this.httpClient.get(this.apiService.endPointsFO.doGetCluZLogItemSyncUpFeedResultAction_SyncUp, { params : _httpParams}).subscribe((res : any) => {
                if(!res) {
                    // FEED NON RETROUVE COTE SERVEUR
                    const query_FEED = this._cashDeskRxDbService.db.cluzlog.find({ selector: { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_FEEDID" : { "$eq": FEED_ID } }, sort: [] });
                    const querySub_FEED = query_FEED.$.subscribe(_documents => {
                        if(_documents){
                            _documents.forEach(x => x.update({ $set : { 'ZSYNCUP_STATUS' : 'unknown', 'ZSYNCUP_ERROR_MESSAGE' : 'Feed non retrouvé sur le serveur' } }));
                        }
                        querySub_FEED.unsubscribe();
                    });
                }
                else {
                    // FEED RETROUVE METTRE A JOUR LES STATUS
                    res.LOG_ITEMS.forEach((_logItem : any) => {
                        const query_OP = this._cashDeskRxDbService.db.cluzlog.findOne({ selector: { "ZSYNCUP_FEEDID" : { "$eq": FEED_ID }, "LOG_GID": { "$eq": _logItem.LOG_GID } }, sort: [] });
                        const querySub_OP = query_OP.$.subscribe(_zCluZLogItem_OP => {
                            if(_zCluZLogItem_OP){
                                let _status : 'unknown' | 'pending' | 'sent' | 'in_progress' | 'completed' | 'error' = 'sent';
                                switch(_logItem.STATUS) { case 0 : _status = 'sent'; break; case 1 : _status = 'in_progress'; break; case 2 : _status = 'completed'; break; case 3 : _status = 'error'; break; }
                                _zCluZLogItem_OP.update({ $set : { 'ZSYNCUP_STATUS' : _status, 'ZSYNCUP_ERROR_MESSAGE' : _logItem.ERROR_MESSAGE } });
                            }
                            querySub_OP.unsubscribe();
                        });
                    });
                }
            }, (err) => {
                console.log(err);
            });
        })
    }
    // #endregion

    // #region ZCluZTickTraceItem
    public async doForceZCluZTickTraceItemSyncUpAction_SyncUp(){
        await this.doRunZCluZTickTraceItemSyncUpAction_SyncUp();
    }

    private async doRunZCluZTickTraceItemSyncUpAction_SyncUp(){
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doRunZCluZTickTraceItemSyncUpAction_SyncUp' , new Date());
        // #region InError
        /*const query_InError = this._cashDeskRxDbService.db.cluzticktrace.find({ selector : { "ZSYNCUP_STATUS" : { "$eq": "error" }}, sort: [] });
        const res_InError = await query_InError.exec();
        await Promise.all(res_InError.map(async (_zCluZTickTraceItem_OP : RxCluZTickTraceDocument) => {
            await _zCluZTickTraceItem_OP.update({
                $set :
                {
                    'ZSYNCUP_FLAG' : 0,
                    'ZSYNCUP_STATUS' : 'pending',
                    'ZSYNCUP_ERROR_MESSAGE' : '',
                    'ZSYNCUP_DATETIME' : '',
                    'ZSYNCUP_FEEDID' : ''
                }
            });
        }));*/
        // #endregion

        const query = this._cashDeskRxDbService.db.cluzticktrace.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 0 }}, sort: [{ "TRACE_DATEEVENT" : 'asc' }] });
        const res = await query.exec();
        let CLU_ZTICKTRACE_ITEMS : any[] = [];
        await Promise.all(res.map(async (ztickTraceItem : RxCluZTickTraceDocument) => {
            CLU_ZTICKTRACE_ITEMS.push(ztickTraceItem.toMutableJSON());
        }));
        //if(CLU_ZTICKTRACE_ITEMS && CLU_ZTICKTRACE_ITEMS.length > 0) { console.log(CLU_ZTICKTRACE_ITEMS); }
        if(CLU_ZTICKTRACE_ITEMS.length == 0) return;
        let reqParams = { ZTRACE_ITEMS : CLU_ZTICKTRACE_ITEMS };
        const resSyncUp = await lastValueFrom(this.httpClient.post<any>(this.apiService.endPointsFO.doRunZCluZTickTraceItemSyncUpAction_SyncUp, reqParams));
        for(const _zCluZTickTraceItem of CLU_ZTICKTRACE_ITEMS){
            const _zCluZTickTraceItem_OP = await this._cashDeskRxDbService.db.cluzticktrace.findOne({ selector: { "TRACE_GID": { "$eq": _zCluZTickTraceItem.TRACE_GID } }, sort: [] }).exec();
            if(_zCluZTickTraceItem_OP){
                await _zCluZTickTraceItem_OP.update({
                    $set :
                    {
                        'ZSYNCUP_FLAG' : 1,
                        'ZSYNCUP_STATUS' : 'sent',
                        'ZSYNCUP_ERROR_MESSAGE' : '',
                        'ZSYNCUP_DATETIME' : moment().local().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z',
                        'ZSYNCUP_FEEDID' : resSyncUp.FEED_ID
                    }
                });
            }
        }
        setTimeout(this.doGetCluZTickTraceItemSyncUpFeedResultAction_SyncUp.bind(this), 3000);
    }

    private async doGetCluZTickTraceItemSyncUpFeedResultAction_SyncUp() {
        let _canSend = await this.canSendItemsToBackend();
        if(!_canSend) return;
        //console.log('doGetCluZTickTraceItemSyncUpFeedResultAction_SyncUp' , new Date());
        const query = this._cashDeskRxDbService.db.cluzticktrace.find({ selector : { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_STATUS" : { "$in": ['sent', 'in_progress'] } }, sort: [] });
        const res = await query.exec();
        if(res.length == 0) return;
        const FEED_IDs = groupBy(res, [{ field : 'ZSYNCUP_FEEDID' }]).map((m : any) => m.value);
        //if(FEED_IDs && FEED_IDs.length > 0) { console.log(FEED_IDs); }
        FEED_IDs.forEach((FEED_ID : string) => {
            let _httpParams = new HttpParams().set('FEED_ID', FEED_ID);
            this.httpClient.get(this.apiService.endPointsFO.doGetCluZTickTraceItemSyncUpFeedResultAction_SyncUp, { params : _httpParams}).subscribe((res : any) => {
                if(!res) {
                    // FEED NON RETROUVE COTE SERVEUR
                    const query_FEED = this._cashDeskRxDbService.db.cluzticktrace.find({ selector: { "ZSYNCUP_FLAG" : { "$eq": 1 }, "ZSYNCUP_FEEDID" : { "$eq": FEED_ID } }, sort: [] });
                    const querySub_FEED = query_FEED.$.subscribe(_documents => {
                        if(_documents){
                            _documents.forEach(x => x.update({ $set : { 'ZSYNCUP_STATUS' : 'unknown', 'ZSYNCUP_ERROR_MESSAGE' : 'Feed non retrouvé sur le serveur' } }));
                        }
                        querySub_FEED.unsubscribe();
                    });
                }
                else {
                    // FEED RETROUVE METTRE A JOUR LES STATUS
                    res.LOG_ITEMS.forEach((_logItem : any) => {
                        const query_OP = this._cashDeskRxDbService.db.cluzticktrace.findOne({ selector: { "ZSYNCUP_FEEDID" : { "$eq": FEED_ID }, "TRACE_GID": { "$eq": _logItem.TRACE_GID } }, sort: [] });
                        const querySub_OP = query_OP.$.subscribe(_zCluZTickTraceItem_OP => {
                            if(_zCluZTickTraceItem_OP){
                                let _status : 'unknown' | 'pending' | 'sent' | 'in_progress' | 'completed' | 'error' = 'sent';
                                switch(_logItem.STATUS) { case 0 : _status = 'sent'; break; case 1 : _status = 'in_progress'; break; case 2 : _status = 'completed'; break; case 3 : _status = 'error'; break; }
                                _zCluZTickTraceItem_OP.update({ $set : { 'ZSYNCUP_STATUS' : _status, 'ZSYNCUP_ERROR_MESSAGE' : _logItem.ERROR_MESSAGE } });
                            }
                            querySub_OP.unsubscribe();
                        });
                    });
                }
            }, (err) => {
                console.log(err);
            });
        })
    }
    // #endregion

    private async canSendItemsToBackend() : Promise<boolean> {
        const SS_LINKUP_WORKSPACE_AUTH_SESSION_KEY = "SS_LINKUP_WORKSPACE_AUTH_SESSION_KEY";
        const lsAuthSessionStr = localStorage.getItem(SS_LINKUP_WORKSPACE_AUTH_SESSION_KEY);
        if (lsAuthSessionStr === 'undefined' || lsAuthSessionStr === 'null') { return false; }
        if(this.coreService.getUIWorkspace() != 'fe-workspace') return false;
        let _canSend = true;
        if(!navigator.onLine) { console.log('no_internet'); _canSend = false; } else { }
        /*let _hasInternet = await this.isOnline();
        if(!_hasInternet) console.log('hasInternet : ', _hasInternet);
        if(!_hasInternet) _canSend = false;*/
        return _canSend;
    }

    private canSendItemsToAgent() : boolean {
        const SS_LINKUP_WORKSPACE_AUTH_SESSION_KEY = "SS_LINKUP_WORKSPACE_AUTH_SESSION_KEY";
        const lsAuthSessionStr = localStorage.getItem(SS_LINKUP_WORKSPACE_AUTH_SESSION_KEY);
        if (lsAuthSessionStr === 'undefined' || lsAuthSessionStr === 'null') { return false; }

        if(this.coreService.getUIWorkspace() != 'fe-workspace') return false;

        const agentState = this.cluAgentService.state$.value;
        return !!agentState?.startupInfos && !!this._apiCluAgentService.endPoints;
    }

}
